import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from '../../../../../shared.module';
import { PriceDatePickerComponent } from '../../price-date-picker/price-date-picker.component';
import { AbstractPricingListDirective } from '../abstract-pricing-list.directive';
import { inOutAnimation } from '../../../../../animations';
import { timePattern } from '../../../../../validators';
import { merge } from 'rxjs';

@Component({
  selector: 'psc-upsert-block-tariff',
  standalone: true,
  imports: [CommonModule, MatIconModule, PriceDatePickerComponent, ReactiveFormsModule, SharedModule, TranslocoModule],
  templateUrl: './upsert-block-tariff.component.html',
  animations: [
    inOutAnimation({}),
  ],
})
export class UpsertBlockTariffComponent extends AbstractPricingListDirective implements OnInit {

  currentStartRange = 0;
  private readonly priceValidators = [Validators.required, Validators.min(0)];

  get blockList(): FormArray {
    return this.formGroup.controls['blockList'] as FormArray;
  }

  get twoTariff(): boolean {
    return this.formGroup.controls['twoTariff'].value;
  }

  blockListElement(index: number) {
    return this.blockList.at(index) as FormGroup;
  }

  ngOnInit() {
    const initialTariff = false;
    const control = new FormControl(initialTariff);
    this.formGroup.addControl('twoTariff', control);
    this.addBlock();
    this.updateFormOnTariff(initialTariff);
    this.subs.sink = control.valueChanges.subscribe((twoTariff) => {
      this.updateFormOnTariff(!!twoTariff);
    });
  }


  updateFormOnTariff(twoTariff: boolean) {
    const controls = [
      'priceKWH_L',
      'priceDistribution_L',
      'priceTransfer_L',
    ];
    if (twoTariff) {
      this.pricingList.setValidators(Validators.required);
    } else {
      this.pricingList.clear();
      this.pricingList.clearValidators();
    }
    this.pricingList.updateValueAndValidity();
    for (let i = 0; i < this.blockList.length; i++) {
      const block = this.blockList.at(i) as FormGroup;
      for (const control of controls) {
        const formControl = block.controls[control];
        if (twoTariff) {
          formControl.setValidators(this.priceValidators);
        } else {
          formControl.setValue(null);
          formControl.clearValidators();
        }
        formControl.updateValueAndValidity();
      }
    }
    this.changeDetectorRef.detectChanges();

  }


  addTimeSlot(index: number) {
    const group = this.formBuilder.group({
      timeFrom: ['', [Validators.required, Validators.pattern(timePattern)]],
      timeTo: ['', [Validators.required, Validators.pattern(timePattern)]],
      highTariff: false,
    });
    this.timeSlots(index).push(group);
    this.subs.sink = merge(
      group.controls['timeFrom'].valueChanges,
      group.controls['timeTo'].valueChanges,
    ).subscribe(() => {
      this.upsertPriceErrors.timeslotsAreNotDayError = false;
    });
  }

  addBlock() {
    if (this.blockList?.length > 0) {
      this.currentStartRange = +this.blockListElement(this.blockList.length - 1).controls?.['range'].value + 1;
    }
    const lowPriceValidators = this.twoTariff ? this.priceValidators : [];
    const group = this.formBuilder.group({
      rangeStart: this.currentStartRange,
      range: ['', [Validators.required, Validators.min(this.currentStartRange)]],
      priceKWH_H: ['', this.priceValidators],
      priceDistribution_H: ['', this.priceValidators],
      priceTransfer_H: ['', this.priceValidators],
      priceKWH_L: [null, lowPriceValidators],
      priceDistribution_L: [null, lowPriceValidators],
      priceTransfer_L: [null, lowPriceValidators],
      priceOIE: ['', this.priceValidators],
    });
    this.blockList.push(group);
  }

  removeBlock(index: number) {
    this.dialogService.openConfirmDialog(() => {
      this.blockList.removeAt(index);
      if (this.blockList.length > 0) {
        this.currentStartRange = this.blockListElement(this.blockList.length - 1).controls?.['rangeStart'].value;
      } else {
        this.currentStartRange = 0;
      }
      this.changeDetectorRef.detectChanges();
    });
  }

}
